import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from "@mui/material";
import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { loginSuccess } from "../../store/store";

const UserTokenDialogBox = (props) => {
  const [token, setToken] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isCognitoAuthenticated = useSelector(
    (state) => state.auth.isCognitoAuthenticated
  );

  const handleBoxOpen = () => {
    props.setBoxClose();
  };
  const handleOnChange = (e) => {
    setToken(e.target.value);
  };
  const handleOnAddToken = () => {
    if (isCognitoAuthenticated) {
      let timeout = null;
      let typeOfLogin = "User Token";
      dispatch(loginSuccess({ token, timeout, typeOfLogin }));
      props.setBoxClose(false);
    }
    return navigate("/home");
  };
  
  return (
    <Dialog open={props.open} onClose={handleBoxOpen} position="absolute" 
    >
      <DialogTitle>Enter Your Token</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="Enter Foundry Token"
          type="text"
          fullWidth
          variant="standard"
          value={token}
          onChange={handleOnChange}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleBoxOpen}>Cancel</Button>
        <Button onClick={handleOnAddToken}>Add Token</Button>
      </DialogActions>
    </Dialog>
  );
};
export default UserTokenDialogBox;
